export const isAppNotificationsInfiniteData = (data) => {
    return (typeof data === 'object' &&
        data !== null &&
        'pages' in data &&
        Array.isArray(data.pages) &&
        data.pages.every((page) => 'has_more' in page &&
            typeof page.has_more === 'boolean' &&
            'next_cursor' in page &&
            (typeof page.next_cursor === 'string' || page.next_cursor === null) &&
            'notifications' in page &&
            Array.isArray(page.notifications) &&
            page.notifications.every((notification) => typeof notification === 'object' &&
                notification !== null &&
                'notification_id' in notification &&
                typeof notification.notification_id === 'string' &&
                'type' in notification &&
                typeof notification.type === 'string' &&
                'is_read' in notification &&
                typeof notification.is_read === 'boolean')));
};
export const prependAppNotification = (data, notification) => {
    if (!isAppNotificationsInfiniteData(data)) {
        return data;
    }
    const firstPage = data.pages[0];
    if (!firstPage) {
        return data;
    }
    const alreadyCached = data.pages.some((page) => page.notifications.some((cachedNotification) => cachedNotification.notification_id === notification.notification_id));
    if (alreadyCached) {
        return data;
    }
    return {
        ...data,
        pages: [
            {
                ...firstPage,
                notifications: [notification, ...firstPage.notifications],
            },
            ...data.pages.slice(1),
        ],
    };
};
//# sourceMappingURL=appNotificationsData.js.map